import { Axios } from "@lib";
import type {
	ChecklistLinksRequest,
	ChecklistResponse,
} from "../types/checklist-links.types";

const getEndpoint = (token: string, isUUID: boolean) => {
	if (isUUID) {
		return `/api/checklist/links/${token}`;
	}
	return `/api/checklist/links/name/${token}`;
};

export const checklistLinks = async ({
	token,
	isUUID,
}: ChecklistLinksRequest) => {
	const endpoint = getEndpoint(token, isUUID);

	const { data } = await Axios.get<ChecklistResponse>(endpoint);

	return data;
};
